module.exports = __webpack_public_path__ + "img/certificadoM7.cdd156b0.png";